module.exports = __webpack_public_path__ + "static/img/4.ceb9244.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/4.png
// module id = 7Pzw
// module chunks = 0